module.exports = __webpack_public_path__ + "static/media/bottle.16bbc338.svg";